/**
 * Product Form — <product-form>
 * Intercepts form submit → fetches via FormData (selling_plan hidden input included automatically).
 * Opens cart drawer with section rendering response.
 *
 * Used by: main-product, product-hero, product-hero-kit, shop-hero, card-product.
 *
 * Note: product-hero.js and product-hero-kit.js have their OWN submit handlers
 * that call evt.preventDefault() + evt.stopImmediatePropagation() BEFORE this fires.
 * For those sections this acts as a fallback only.
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (!this.form) return;

      const idInput = this.form.querySelector('[name=id]');
      if (idInput) idInput.disabled = false;

      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

      this.submitButton = this.querySelector('[type="submit"]');
      if (this.submitButton && document.querySelector('cart-drawer')) {
        this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();

      if (!this.submitButton) return;
      if (this.submitButton.disabled) return;

      this.handleErrorMessage();

      // --- Loading state ---
      const originalText = this.submitButton.textContent;
      this.submitButton.disabled = true;
      this.submitButton.textContent = window.variantStrings?.adding || 'Adding...';

      try {
        const formData = new FormData(this.form);
        formData.append('sections', 'cart-drawer');
        formData.append('sections_url', window.location.pathname);

        const response = await fetch(routes.cart_add_url + '.js', {
          method: 'POST',
          body: formData
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.description || 'Could not add to cart');
        }

        const data = await response.json();

        // --- Open cart drawer with updated section HTML ---
        const cartDrawerEl = document.querySelector('cart-drawer');
        if (cartDrawerEl) {
          await customElements.whenDefined('cart-drawer');
          cartDrawerEl.renderContents(data);
        }

        // --- Success feedback ---
        this.submitButton.textContent = window.variantStrings?.added || 'Added';
        setTimeout(() => {
          this.submitButton.textContent = originalText;
          this.submitButton.disabled = false;
        }, 1500);

      } catch (error) {
        console.error('Add to cart error:', error);
        this.handleErrorMessage(error.message || 'Could not add to cart');

        // --- Restore button immediately on error ---
        this.submitButton.textContent = originalText;
        this.submitButton.disabled = false;
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
